"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var page_not_found_svg_1 = __importDefault(require("@assets/page-not-found/page-not-found.svg"));
var BaseLayout_1 = __importDefault(require("../../BaseLayout"));
var useStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return styles_1.createStyles({
        grid: {
            maxWidth: '1190px',
            margin: '0 auto',
        },
        gridItem: {
            justifyContent: 'center',
        },
        image: (_a = {
                maxHeight: '530px'
            },
            _a[theme.breakpoints.down('md')] = {
                maxHeight: '330px',
            },
            _a),
        boxPageNotFound: {
            padding: '10px 25px 10px 25px',
            border: '1px solid #E4E4E4',
            backgroundColor: '#E4E4E4',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '18px',
        },
        heroContent: {
            margin: '0 auto',
            padding: theme.spacing(8, 2, 6),
            textAlign: 'left',
        },
        btnGoToHomePage: {
            padding: '10px 25px 10px 25px',
            border: '1px solid #FFC700',
            backgroundColor: '#FFC700',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '18px',
            color: 'white',
        },
    });
});
var NotFoundPage = function (_a) {
    var match = _a.match;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles();
    var params = match.params;
    var shortUrl = params.shortUrl;
    var message = shortUrl ? (react_1.default.createElement(react_1.default.Fragment, null,
        "Are you sure",
        ' ',
        react_1.default.createElement("strong", null,
            document.location.host,
            "/",
            shortUrl),
        ' ',
        "was a valid GoGovKH link?")) : (react_1.default.createElement("span", null, t('message.notFound.invalidLink')));
    return (react_1.default.createElement(BaseLayout_1.default, { layoutStyle: { backgroundColor: 'white' } },
        react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "flex-start", className: classes.grid },
            react_1.default.createElement(core_1.Grid, { container: true, item: true, spacing: 2, md: 6, xs: 12, className: classes.gridItem },
                react_1.default.createElement("img", { className: classes.image, src: page_not_found_svg_1.default, alt: "page-not-found" })),
            react_1.default.createElement(core_1.Grid, { container: true, item: true, spacing: 2, md: 6, xs: 12, className: classes.gridItem },
                react_1.default.createElement("div", { className: classes.heroContent },
                    react_1.default.createElement(core_1.Box, { component: "span", className: classes.boxPageNotFound }, t('general.pageNotFound')),
                    react_1.default.createElement(core_1.Typography, { variant: "h3", color: "textPrimary", gutterBottom: true, style: { marginTop: '30px', fontWeight: 600, fontSize: '54px' } }, t('message.notFound.howOdd')),
                    react_1.default.createElement(core_1.Typography, { variant: "h5", color: "textPrimary", gutterBottom: true }, t('message.notFound.nothingFound')),
                    react_1.default.createElement(core_1.Typography, { color: "textPrimary", gutterBottom: true, style: { marginBottom: '30px' } }, message),
                    react_1.default.createElement(core_1.Button, { className: classes.btnGoToHomePage, variant: "contained", href: "/#/" }, t('button.backHome')))))));
};
exports.default = NotFoundPage;
